import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  FormControl,
  FormHelperText,
} from "@mui/material";

const CustomMultiAutocompleteField = ({
  value = [], // array of selected options
  onChange,
  placeholder,
  options,
  rule,
  disabled,
  variant = "outlined",
  searchBy = "userId",
  displayField = "namaAnggota",
  withCost = false,
  costField = "biaya",
  ...props
}) => {
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

  const handleValidation = (val) => {
    if (rule) {
      const { isValid, errorMessage } = rule(val);
      setError(!isValid);
      setHelperText(errorMessage);
    }
  };

  const handleChange = (event, newValue) => {
    onChange(newValue); // array of selected objects
    handleValidation(newValue);
  };

  const handleBlur = () => {
    handleValidation(value);
  };

  const formatLabel = (option) => {
    const label =
      option?.[displayField] || option?.namaAnggota || option?.name || "";
    const costValue = option?.[costField];

    return withCost && costValue
      ? `${label} - Rp ${Number(costValue).toLocaleString("id-ID")}`
      : label;
  };

  return (
    <FormControl fullWidth error={error}>
      <Autocomplete
        multiple
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
        options={options}
        isOptionEqualToValue={(option, val) =>
          option[searchBy] === val[searchBy]
        }
        getOptionLabel={(option) => formatLabel(option)}
        renderOption={(props, option) => (
          <li {...props} key={option[searchBy]}>
            {formatLabel(option)}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            variant={variant}
            error={error}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 5,
                ...(disabled && {
                  backgroundColor: "#E0E0E0",
                }),
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: 5,
              },
              ...(disabled && {
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "unset",
                },
              }),
            }}
          />
        )}
        {...props}
      />
      {error && (
        <FormHelperText>
          {helperText || "Please select at least one value"}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomMultiAutocompleteField;